import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hotel_data",
  "use": "icon-hotel_data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hotel_data\"><path d=\"M825.6 473.6V832H896v64H128v-64h64v-121.6h64V832h128V531.2h64V832h128v-179.2h64V832h128V473.6h57.6zM896 128v268.8h-64V230.4L620.8 441.6l-51.2 44.8-108.8-108.8-275.2 275.2-44.8-44.8 320-320L576 396.8 780.8 192H640V128h256z\" p-id=\"1111\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol